import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { stepAndRouteMap } from "src/constants";

const useGetStep = () => {
  const accountState = useSelector((state:RootState) => state.account);
  const stepsList = Object.keys(stepAndRouteMap);

  const onContinueAcOpening = (): string => {
    const currentStep = accountState.userDetails.nextStep;
    const showCompletedScreens = ["verification_pending", "verified", "re_verification"];
    if (currentStep) {
      if (showCompletedScreens.includes(currentStep)) {
        return "/completed"
      } if (!stepsList.includes(currentStep)) {
        return "/completed"
      }
      return `${stepAndRouteMap[currentStep][0]}`
    }
    return "/"
  };
  return { onContinueAcOpening };
}

export default useGetStep;
